import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { useUserInspectorDataViewLogic } from "./hooks/useUserInspectorDataViewLogic";
import ReportDownload from "src/components/Common/UI/ReportDownload/ReportDownload";


const UserInspectorDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    actionEvent,
    modalEvent,
    downloadAnchorRef,
    canDownloadCsv,
    totalRercords
  } = useUserInspectorDataViewLogic();

  const DownloadComponent: React.FC = () => (
    <ReportDownload event={actionEvent} canDownloadCsv={canDownloadCsv} canDownloadExcel={false} />            
  );


  return (
    <>
     <a ref={downloadAnchorRef} href="#" style={{ display: 'none' }} />
        {loadingDone && (
          <>
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={true}
                rowSelection={false}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No UserInspector data yet"
                isChangeOrderOrVisibilityEnable={false}
                hiddenColumnsForUser={["deleted", "id"]}
                textPosition="center"
                maxHeight="33rem"
                /* ButtonsAreaRight={DownloadComponent} */
                numberOfRows={totalRercords}
                numberOfRowsTitle="Συνολικές Κινήσεις"
            />
          </>
        )}

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default UserInspectorDataView;

